import { render, staticRenderFns } from "./PageCreateOrEditEvaluationAssessment.vue?vue&type=template&id=53ba24c2&"
import script from "./PageCreateOrEditEvaluationAssessment.vue?vue&type=script&lang=js&"
export * from "./PageCreateOrEditEvaluationAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports